import { useOne } from 'admin';
import { Load } from 'api';
import { useSearchParams } from 'react-router-dom';

export const useSearchedLoad = () => {
  const [searchParams] = useSearchParams();

  const loadId = searchParams.get('loadId');

  return useOne<Load>({
    id: loadId || undefined,
    queryOptions: {
      enabled: Boolean(loadId),
    },
    resource: '/inspections/v1/loads',
  });
};
